import axios from 'axios';

const RESOURCE_NAME = '/user';

export default {

    getCurrentUserData() {
        return axios.get(`${RESOURCE_NAME}/get-current-user-data`)
    },

    getColumns(type) {
        return axios.get(`${RESOURCE_NAME}/get-columns?type=${type}`)
    },

    getColumnsForTracker(trackerId) {
        return axios.get(`${RESOURCE_NAME}/get-columns?type=tracker-startups&tracker_id=${trackerId}`)
    },

    getColumnsForManage(type, trackerId = 0) {
        return axios.get(`${RESOURCE_NAME}/get-columns-for-manage?type=${type}&tracker_id=${trackerId}`)
    },

    updateColumns(type, trackerId = 0, columns) {
        return axios.post(`${RESOURCE_NAME}/update-columns?type=${type}&tracker_id=${trackerId}`, {'columns': columns})
    },

    getList() {
        return axios.get(`${RESOURCE_NAME}/get-list`)
    },

    updateSettings(data) {
        return axios.post(`${RESOURCE_NAME}/update-settings`, data)
    },

    getNotificationSettings() {
        return axios.get(`${RESOURCE_NAME}/get-notification-settings`)
    },

    updateNotificationSettings(data) {
        return axios.post(`${RESOURCE_NAME}/update-notification-settings`, data)
    },

    getProfileEdit() {
        return axios.get(`${RESOURCE_NAME}/get-profile-edit`)
    },

    saveProfile(data) {
        return axios.post(`${RESOURCE_NAME}/save-profile`, data)
    },

    getTaskType(startupId, trackerId) {
        return axios.get(`${RESOURCE_NAME}/get-task-type?startup_id=${startupId}&tracker_id=${trackerId}`)
    },

    saveTrackerFilter(filterType) {
        return axios.post(`${RESOURCE_NAME}/save-tracker-filter`, {filterType: filterType})
    },

}